import { memo, type PropsWithChildren } from "react";

import { type TTailwindString, tw } from "classnames";

interface Props {
  className?: TTailwindString;
}

const styles = {
  wrapper: (className?: TTailwindString) =>
    tw(
      "splide__arrows" as TTailwindString,
      "pointer-events-none",
      className ? tw(className) : undefined
    ),
};

const CarouselArrowsBase = ({
  children,
  className,
}: PropsWithChildren<Props>) => (
  <div className={styles.wrapper(className)}>{children}</div>
);

export const CarouselArrows = memo(CarouselArrowsBase);
